import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 bg-amber-500 relative overflow-hidden" data-id="element-102">
      {/* Abstract background shapes */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-103">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-400 rounded-full mix-blend-multiply filter blur-2xl opacity-70" data-id="element-104"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-amber-600 rounded-full mix-blend-multiply filter blur-2xl opacity-70" data-id="element-105"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-106">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-extrabold text-charcoal-950 mb-6 tracking-tight" data-id="element-107">
          Ready to Take Back Control?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-charcoal-900 mb-10 font-medium" data-id="element-108">
          Understand your pain, build a clear plan, and get back to doing what
          you love. Book a free consultation to see how we can work together.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-109">
          <a href="https://mcleanphysicaltherapy.janeapp.com/#staff_member/1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-charcoal-950 hover:bg-charcoal-800 text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl" data-id="element-110">
            Book Now
            <ArrowRightIcon size={20} data-id="element-111" />
          </a>
        </motion.div>
      </div>
    </section>;
}